import React, { useRef, useState } from "react";
import { Music, Pause } from "lucide-react";

// "Jingle Bells" by Kevin MacLeod (incompetech.com), licensed CC BY 4.0. Off by default, loops.
export const MusicPlayer = () => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.volume = 0.35;
      a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/christmas-tune.mp3" loop preload="none" />
      <button
        data-testid="music-toggle"
        onClick={toggle}
        aria-pressed={playing}
        aria-label={playing ? "Pause Christmas music" : "Play Christmas music"}
        className={`fixed bottom-5 left-5 z-[80] flex items-center gap-2 border-4 border-candy-gold rounded-full p-3 sm:py-2.5 sm:px-4 shadow-brutal-sm active:translate-x-1 active:translate-y-1 active:shadow-none transition-transform duration-150 font-bold uppercase text-xs tracking-wider text-white ${
          playing ? "bg-candy-pink" : "bg-candy-teal"
        }`}
      >
        {playing ? <Pause className="h-4 w-4" /> : <Music className="h-4 w-4 animate-pulse" />}
        <span data-testid="music-toggle-label" className="hidden sm:inline">{playing ? "Pause Music" : "Play Music"}</span>
      </button>
    </>
  );
};
